import Vue from 'vue'
import Vuex from 'vuex'
import answerList from './answerList'

Vue.use(Vuex)

const store = {
  modules: {
    answerList
  }
}
export default new Vuex.Store(store)
